import { useEffect, useState } from "react";

export type ThemeMode = "auto" | "light" | "dark";
const KEY = "crm-theme";

function read(): ThemeMode {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "auto";
  } catch {
    return "auto";
  }
}

export function useTheme(): [ThemeMode, () => void] {
  const [mode, setMode] = useState<ThemeMode>(read);
  useEffect(() => {
    const r = document.documentElement;
    if (mode === "auto") r.removeAttribute("data-theme");
    else r.setAttribute("data-theme", mode);
    try {
      if (mode === "auto") localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, mode);
    } catch {
      /* stockage indisponible : le thème reste valable pour la session */
    }
  }, [mode]);
  const cycle = () => setMode((m) => (m === "auto" ? "light" : m === "light" ? "dark" : "auto"));
  return [mode, cycle];
}
